/**
 * Deep Research timeout defaults — keep in sync with
 * cascade-node-server/config/research.js
 */
export const RESEARCH_TIMEOUT_DEFAULT_MINUTES = 30;
export const RESEARCH_TIMEOUT_MIN_MINUTES = 5;
export const RESEARCH_TIMEOUT_MAX_MINUTES = 120;
